export default __webpack_public_path__ + "static/media/Punto_02_Fortezza_Vecchia_e_Darsena_Vecchia_ENG_Def.a848cc48.aac";